module.exports = __webpack_public_path__ + "static/gmail-security-579d858769a7644e5da2e7cc4ed3e854.png";